export default __webpack_public_path__ + "static/media/github.7c8fb24c.svg";